import * as React from "react"
import { graphql } from "gatsby"
import Layout from "../components/layout"
import Seo from "../components/seo"
import OtherNews from "../components/OtherNews"
import InterestingArticle from "../components/InterestingArticle"
import HashTags from "../components/HashTags"
import styled from "styled-components"
import EmptyWarning from "../components/EmptyWarning"
import PortableText from "../components/PortableText"
import PortableTextFull from "../components/PortableTextFull"
import Image from "gatsby-plugin-sanity-image"
import { FaRegEnvelope } from "react-icons/fa"
import { HiOutlinePhone } from "react-icons/hi"
import SocialButtons from "../components/SocialButtons"
import AmosovaLeftBanner from "../components/ads/AmosovaLeftBanner"
import AmosovaBigTopBanner from "../components/ads/AmosovaBigTopBanner"

const ContactsPage = ({ data }) => {
  const tinyListNews = data.tinylist.nodes
  const {
    _rawDescription,
    _rawEnteringText,
    headerAuthors,
    author,
    phoneUrl,
    telegramUrl,
    title,
    twitterUrl,
    vkUrl,
    youtubeUrl,
    facebookUrl,
    instagramLink,
    email,
  } = data.sanityContacts
  return (
    <Layout>
      <Seo title={title || `Контакты`} />
      {data.sanityAdBanner.positionsOtherPages.topBar && (
        <AmosovaBigTopBanner />
      )}
      <div className="max-w-screen-xl mx-auto">
        <div className="grid grid-cols-4">
          <div className="col-span-4 md:col-span-2 lg:col-span-3 p-5">
            <h3 className="article-name-big-article">{title}</h3>
            <PortableText textData={_rawDescription} />
            <div className="block lg:flex justify-between border-t border-b border-gray-400 mt-5">
              <div className="p-5  rounded-b">
                <section className="flex">
                  <FaRegEnvelope className="text-3xl mr-5 text-gray-700" />
                  <a
                    href={email}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="email"
                    className="font-semibold text-lg hover:underline"
                  >
                    {email.replace("mailto: ", "")}
                  </a>
                </section>
                <section className="flex pt-5">
                  <HiOutlinePhone className="text-3xl mr-5 text-gray-700" />
                  <a
                    href={phoneUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="phone"
                    className="font-semibold text-lg hover:underline"
                  >
                    {phoneUrl.replace("tel: ", "")}
                  </a>
                </section>
              </div>
              <div>
                <section className="py-5">
                  <SocialButtons
                    telegramUrl={telegramUrl}
                    instagramUrl={instagramLink}
                    twitterUrl={twitterUrl}
                    youtubeUrl={youtubeUrl}
                    facebookUrl={facebookUrl}
                    vkUrl={vkUrl}
                  />
                </section>
              </div>
            </div>
            <div className="p-5 grid grid-cols-2 gap-5">
              <div className="col-span-2">
                <h4 className="article-name-big-article">
                  О проекте Finanzas de bolsillo
                </h4>
                <PortableTextFull textData={_rawEnteringText} />
              </div>
              <div className="col-span-2">
                <h4 className="article-name pb-5">{headerAuthors}</h4>
                <div className="divide-y divide-gray-300">
                  <div className="grid grid-cols-2 gap-5">
                    {author.map(item => (
                      <div className="col-span-2" key={item.id}>
                        <div className="grid grid-cols-4 gap-5">
                          <div className="col-span-4 sm:col-span-1 md:col-span-4 lg:col-span-1 flex justify-center">
                            <Image
                              // pass asset, hotspot, and crop fields
                              {...item._rawImage}
                              // tell Sanity how large to make the image (does not set any CSS)
                              width={300}
                              height={300}
                              alt={item.name}
                              className="rounded-full shadow m-5"
                              // style it how you want it
                              style={{
                                width: "150px",
                                height: "150px",
                                objectFit: "cover",
                              }}
                            />
                          </div>
                          <div className="col-span-4 sm:col-span-3 md:col-span-4 lg:col-span-3 text-center md:text-left pt-0 lg:pt-5">
                            <p className="font-opensanscond font-bold text-4xl text-fb-blue">
                              {item.name}
                            </p>
                            <p className="inline-flex font-roboto font-semibold text-normal text-gray-700">
                              Редактор
                            </p>
                            <SocialButtons
                              telegramUrl={item.telegramUrl}
                              instagramUrl={item.instagramUrl}
                              twitterUrl={item.twitterUrl}
                              youtubeUrl={item.youtubeUrl}
                              facebookUrl={item.facebookUrl}
                              vkUrl={item.vkUrl}
                              phoneUrl={item.phoneUrl}
                              email={item.email}
                            />
                          </div>
                          <div className="col-span-4 bg-fb-blue bg-opacity-10 styledline rounded">
                            <div className="px-5">
                              <PortableTextFull textData={item._rawBio} />
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-span-4 md:col-span-2 lg:col-span-1">
            <div className="bg-fb-blue bg-opacity-5">
              {data.sanityAdBanner.positionsOtherPages.leftBar && (
                <AmosovaLeftBanner />
              )}
              <div className="relative" style={{ height: "60px" }}>
                <CategoryBar className="bg-fb-blue rounded-none md:rounded flex items-center pl-5 font-opensanscond category-bar inherit md:absolute">
                  Лента новостей
                </CategoryBar>
              </div>
            </div>
            <div className="divide-y divide-gray-300 px-3 bg-fb-blue bg-opacity-5">
              {tinyListNews.length === 0 && <EmptyWarning />}
              {tinyListNews.map((tinyNews, index) => (
                <OtherNews
                  as="div"
                  key={index}
                  themeColor={tinyNews.categories.color}
                  title={tinyNews.title}
                  category={tinyNews.categories.title}
                  categoryLink={tinyNews.categories.slug.current}
                  link={tinyNews.slug.current}
                />
              ))}
            </div>
            <InterestingArticle />
            <HashTags />
          </div>
        </div>
      </div>
    </Layout>
  )
}

export const query = graphql`
  {
    sanityContacts {
      youtubeUrl
      vkUrl
      twitterUrl
      title
      telegramUrl
      phoneUrl
      instagramLink
      headerAuthors
      facebookUrl
      email
      _rawDescription(resolveReferences: { maxDepth: 10 })
      _rawEnteringText(resolveReferences: { maxDepth: 10 })
      author {
        id
        _rawBio
        _rawImage(resolveReferences: { maxDepth: 10 })
        email
        facebookUrl
        instagramUrl
        name
        phoneUrl
        telegramUrl
        twitterUrl
        vkUrl
        youtubeUrl
      }
    }
    tinylist: allSanityPost(
      sort: { fields: publishedAt, order: DESC }
      limit: 8
    ) {
      nodes {
        title
        categories {
          title
          slug {
            current
          }
          color
        }
        slug {
          current
        }
      }
    }
    sanityAdBanner(id: { eq: "-6025e2e7-5795-581f-97b5-7436c86dbe7b" }) {
      positionsOtherPages {
        topBar
        leftBar
      }
    }
  }
`
const CategoryBar = styled.div`
  bottom: 0px;
  right: 5px;
  width: 100%;
  height: 60px;
`
export default ContactsPage
